import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Gift, ArrowLeft, Sparkles, Plus } from "lucide-react";
import { api, fmtPrice } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import OliveLeaves from "@/components/OliveLeaves";

export default function BoxPage() {
  const [box, setBox] = useState(null);
  const [opened, setOpened] = useState(false);
  const [step, setStep] = useState(0);
  const { add } = useCart();

  const open = async () => {
    const r = await api.get("/box");
    setBox(r.data);
    setOpened(true);
    setStep(0);
  };

  const items = box?.items || [];
  const current = items[step];
  const isLast = step >= items.length - 1;

  return (
    <div className="relative min-h-screen overflow-hidden bg-olive-deep pt-24 text-ivory">
      <div className="tatreez-bg absolute inset-0 opacity-15" />
      <OliveLeaves count={10} />
      <div className="relative mx-auto flex min-h-[80vh] max-w-2xl flex-col items-center justify-center px-6 py-12 text-center">
        {!opened ? (
          <>
            <Sparkles className="mb-4 h-8 w-8 text-earth" />
            <h1 className="font-display text-3xl font-bold sm:text-4xl">افتح صندوق فلسطين</h1>
            <p className="mt-3 max-w-md text-ivory/75">صندوق مغلق يحمل مفاجآت من أرضنا. افتحه لتكتشف منتجاً تلو الآخر مع حكايته.</p>
            <button data-testid="open-box-btn" onClick={open}
              className="btn-shine group mt-10 flex flex-col items-center gap-4">
              <span className="flex h-40 w-40 items-center justify-center rounded-[2rem] border-2 border-earth/40 bg-ivory/5 transition-transform duration-500 group-hover:scale-105 group-hover:-rotate-2">
                <Gift className="h-20 w-20 text-earth transition-transform duration-500 group-hover:scale-110" />
              </span>
              <span className="rounded-full bg-earth px-8 py-3 font-semibold text-ivory">افتح الصندوق</span>
            </button>
          </>
        ) : current ? (
          <div key={step} className="w-full animate-fade-up">
            <div className="mb-4 text-sm text-ivory/60">{step + 1} من {items.length}</div>
            <div className="mx-auto max-w-sm overflow-hidden rounded-[2rem] border border-ivory/10 bg-ivory/5">
              <img src={current.image} alt={current.name_ar} className="aspect-square w-full object-cover" />
              <div className="p-6 text-right">
                <h2 className="font-display text-2xl font-bold">{current.name_ar}</h2>
                <p className="mt-2 text-sm leading-relaxed text-ivory/75">{current.story}</p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="font-display text-lg font-bold text-earth">{fmtPrice(current.price)}</span>
                  <button data-testid="box-add" onClick={() => add({ sku: current.sku, slug: current.slug, name_ar: current.name_ar, price: current.price, images: { main: current.image } })}
                    className="flex items-center gap-1.5 rounded-full bg-ivory px-4 py-2 text-sm font-medium text-olive-dark"><Plus className="h-4 w-4" /> أضف للسلة</button>
                </div>
              </div>
            </div>
            <div className="mt-8 flex items-center justify-center gap-3">
              <Link to={`/product/${current.slug}`} className="rounded-full border border-ivory/30 px-6 py-3 text-sm font-medium text-ivory">اكتشف قصته</Link>
              {!isLast ? (
                <button data-testid="box-next" onClick={() => setStep((s) => s + 1)} className="flex items-center gap-1.5 rounded-full bg-earth px-6 py-3 text-sm font-semibold text-ivory">المنتج التالي <ArrowLeft className="h-4 w-4" /></button>
              ) : (
                <Link to="/store" className="rounded-full bg-earth px-6 py-3 text-sm font-semibold text-ivory">تصفّح كل المنتجات</Link>
              )}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
